import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ROLE_LABELS } from "@/context/AuthContext";
import { fmtDate } from "@/components/ui-kit";
import { AlertTriangle } from "lucide-react";

export function AbsenceAlertsCard({ refreshKey }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/hr/absence-alerts").then((r) => setData(r.data)).catch(() => {}); }, [refreshKey]);
  if (!data) return null;
  return (
    <div data-testid="absence-alerts-card" className="bg-white rounded-2xl shadow-sm p-4 mb-5 border-l-4 border-rose-500">
      <div className="flex items-center gap-2 mb-1">
        <AlertTriangle size={18} className="text-rose-600" />
        <h3 className="font-bold">Absence alerts</h3>
        <span className="text-xs text-slate-500 ml-auto">Week from {fmtDate(data.week_start)} • month {data.month}</span>
      </div>
      {data.rows.length === 0 ? <p data-testid="absence-alerts-empty" className="text-sm text-slate-500">No absences, half days or late marks this month.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm mt-2">
            <thead className="text-xs text-slate-500"><tr><th className="text-left py-1">Staff</th><th className="px-2">This week</th><th className="px-2">Absent (month)</th><th className="px-2">Half days</th><th className="px-2">Late</th><th className="px-2">Late cut</th></tr></thead>
            <tbody className="divide-y divide-slate-100">
              {data.rows.map((r) => (
                <tr key={r.id} data-testid={`absence-alert-${r.id}`}>
                  <td className="py-1.5"><span className="font-semibold">{r.name}</span> <span className="text-xs text-slate-500">{ROLE_LABELS[r.role]}</span></td>
                  <td className="text-center px-2">{r.week_absent}</td>
                  <td className="text-center px-2 font-bold text-rose-700">{r.absent}</td>
                  <td className="text-center px-2">{r.half_day}</td>
                  <td className="text-center px-2 text-sky-700">{r.late}</td>
                  <td className="text-center px-2">{Math.floor(r.late / 3) * 0.5} day</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
